import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import ContentSections from './components/ContentSections';
import SEOArticleGrid from './components/SEOArticleGrid';
import CTASection from './components/CTASection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://vigorbuyspread.sbs';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Kakobuy Spreadsheet Hub',
  url: siteUrl,
  description: 'The ultimate product discovery database for smart shopping. Curated spreadsheets, QC information, and organized product lists updated daily.',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Kakobuy Spreadsheet Hub',
  url: siteUrl,
  description: 'Discover the latest Kakobuy Spreadsheet 2026 with organized product lists, QC information, shopping guides, and updated shopping resources.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://kaspreadsheet.com/search?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <ContentSections />
        <SEOArticleGrid />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}